// this file allows us to mock out debounce in unit/integration tests
import debounce from 'react-utils/debounce';
export { debounce };